import { BasePortal, MainLoading } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import SatModule from '../../satModule';
import SatV5Zone from '../../satV5Zone';
import { app } from './routes';

const Home = lazy(() => import('../pages/home'));
const AccessDenied403 = lazy(() => import('../pages/access-denied-403'));
const NotFound = lazy(() => import('../pages/not-found'));

function AppRoutes() {
  return (
    <Suspense fallback={<MainLoading />}>
      <Routes>
        <Route path="*" element={<NotFound />} />

        <Route element={<BasePortal microSystem showUserRole />}>
          <Route path={app.base} element={<Home />} />
        </Route>
        <Route path={app.unauthorized} element={<AccessDenied403 />} />

        <Route path={`${app.satV5Zone}/*`} element={<SatV5Zone />} />
        <Route path={`${app.satModule}/*`} element={<SatModule />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
